import {
  DI_ADHERENCE,
  DI_ADHERENCE_COMPANY_CODE,
  DI_ADHERENCE_LOCATION,
  DI_ADHERENCE_REPORT,
  DI_ADHERENCE_TOTAL,
} from "../../config/apiList";
import { contentType, methodType } from "../../config/auth";
import { apiRequest } from "../../utility/apiWrapper";

//dept, vendor, division
export const getDiAdherence = (
  aggr,
  startDate,
  endDate,
  division,
  department,
  vendor,
  companyCodes,
  diLocations,
  page,
  limit,
  sort
) => {
  const requestURL = DI_ADHERENCE;
  let obj = { group_by: aggr, from_date: startDate, to_date: endDate };

  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }

  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }

  if (vendor && vendor.length) {
    obj["vendor_list"] = vendor.join(",");
  }

  if (companyCodes && companyCodes.length) {
    obj["company_code"] = companyCodes.join(",");
  }

  if (diLocations && diLocations.length) {
    obj["di_location"] = diLocations.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: { ...obj, page: page, limit: limit, sort: sort },
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getDiAdherenceReport = (
  startDate,
  endDate,
  division,
  department,
  vendor,
  companyCodes,
  diLocations,
  requestId
) => {
  const requestURL = DI_ADHERENCE_REPORT;
  let obj = { from_date: startDate, to_date: endDate, request_id: requestId };

  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }

  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }

  if (vendor && vendor.length) {
    obj["vendor_list"] = vendor.join(",");
  }

  if (companyCodes && companyCodes.length) {
    obj["company_code"] = companyCodes.join(",");
  }

  if (diLocations && diLocations.length) {
    obj["di_location"] = diLocations.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getCompanyCodeDetails = () => {
  const requestURL = DI_ADHERENCE_COMPANY_CODE;

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: {},
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getDILocationDetails = () => {
  const requestURL = DI_ADHERENCE_LOCATION;

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: {},
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getDiAdherenceTotal = (
  startDate,
  endDate,
  division,
  department,
  vendor,
  companyCodes,
  diLocations
) => {
  const requestURL = DI_ADHERENCE_TOTAL;
  let obj = { from_date: startDate, to_date: endDate };

  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }

  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }

  if (vendor && vendor.length) {
    obj["vendor_list"] = vendor.join(",");
  }

  if (companyCodes && companyCodes.length) {
    obj["comp_code_list"] = companyCodes.join(",");
  }

  if (diLocations && diLocations.length) {
    obj["di_location_list"] = diLocations.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};
